<template>
  <v-app>
    <div class="sobre-curso" v-if="courseLoaded">
      <course-page :course="course">
        <template v-slot:header>
          <header class="pt-0">

            <div class="white-bg">
              <public-header></public-header>
              <v-progress-linear indeterminate v-if="loadingCourse"></v-progress-linear>
            </div>


            <!-- BANNER TOPO -->
            <div class="banner-public-course">
              <h2 class="title">{{ course.title }}</h2>
            </div>

            <!-- THUMB E INFO ESCOLA -->
            <course-page-header :course="course" :user-has-course="false" :loading-add="loadingAdd"
                                @addCourse="addCourse"
                                @buyCourse="addCourse">
            </course-page-header>
          </header>


        </template>
      </course-page>

      <div class="destaque-compra">
        <div class="container-fluid">
          <v-row>
            <v-col cols="12" sm="12" md="5" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                   data-wow-offset="40">
              <img src="@/assets/lp/images/banner-4.png" alt="" class="img-fluid"/>
            </v-col>
            <v-col cols="12" sm="12" md="7" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
                   data-wow-offset="40">
              <h5>Tem mais!</h5>
              <ul>
                <li>
                  <v-icon>menu_book</v-icon>
                  Total de {{ totalClass }} {{ (totalClass > 1) ? 'aulas' : 'aula' }}
                </li>
                <li>
                  <v-icon>play_circle_filled</v-icon>
                  {{ course.workload }} horas de duração
                </li>
              </ul>

              <ul>
                <li>
                  <v-icon>home</v-icon>
                  Acesso vitalício ao curso
                </li>
                <li>
                  <v-icon>star</v-icon>
                  Certificado de conclusão
                </li>
              </ul>

              <div class="destaque-compra-price">
                <!--<p class="price-offer">R$245,00</p><br />-->
                <p class="price" color="success" v-if="course.price">R${{ priceValue }}, <span>{{ priceCents }}</span>
                  <v-btn dark>Compre agora</v-btn>
                </p>
                <p class="price-free" color="success" v-else>Gratuito
                  <v-btn dark>Acesse já</v-btn>
                </p>
                <span style="margin-top:10px;"
                      v-if="course.price">Garantia de devolução do dinheiro em até 30 dias</span>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <footer class="lp"><img src="@/assets/lp/images/mundi-play-logo-rodape.png" alt=""/></footer>
    </div>

    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
    >
      <v-row no-gutters>
        <v-col cols="10" class="text-left">
          {{ alert.text }}
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            text
            icon
            x-small
            @click="alert.show = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import '@/assets/lp/style.css'
import '@/assets/lp/animate.min.css'
import PublicHeader from '@/components/Public/Header'
import CoursePage from '@/components/CoursePage'
import CoursePageHeader from '@/components/CoursePageHeader'
import { CourseModel } from '@/models/Course'
import { priceDivider } from '@/helpers'

export default {
  name: 'PublicCoursePage',
  components: { PublicHeader, CoursePage, CoursePageHeader },
  data () {
    return {
      loadingAdd: false,
      loadingCourse: false,
      courseLoaded: false,
      navigationEnabled: false,
      course: {},
      drawer: false,
      alert: {
        show: false,
        text: null,
        color: null
      }
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    priceValue () {
      return priceDivider(this.course.priceWithTax).value
    },
    priceCents () {
      const cents = priceDivider(this.course.priceWithTax).cents

      return cents || '00'
    },
    totalClass () {
      let total = this.course.contents.length

      for (const module of this.course.modules) {
        total += module.contents.length
      }

      return total
    }
  },
  created () {
    this.getCourse()
  },
  methods: {
    ...mapActions(['setPublicCourseEnter', 'clearPublicCourseEnter']),
    addCourse () {
      const userId = this.getUser.id

      if (userId) {
        this.loadingAdd = true
        /* eslint-disable no-undef */
        grecaptcha.ready(() => {
          grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY_SITE, { action: 'submit' }).then(token => {

            this.axios.post(`/user/course/enter`, { slug: this.course.slug, token }).then(({ data }) => {
              if (data.success) {
                this.$router.push({ name: 'home' })
              } else {
                this.alert.color = 'error'
                this.alert.text = data.message
                this.alert.show = true
              }
            }).catch(err => {
              console.error(err)

              this.alert.color = 'error'
              this.alert.text = 'Erro ao entrar no curso'
              this.alert.show = true
            }).finally(() => {
              this.loadingAdd = false
            })
          }).catch(err => {
            console.error(err)

            this.showAlert = true
            this.colorAlert = 'error'
            this.textAlert = 'Erro ao buscar o reCaptcha'
          })
        })
      } else {
        this.setPublicCourseEnter(this.course.slug)
        this.$router.push({ name: 'login-enter' })
      }
    },
    getCourse () {
      this.loadingCourse = true

      this.axios.get(`/public/course/view/${this.$route.params.slug}`).then(({ data }) => {
        if (data.success) {
          this.course = new CourseModel(data.course.title, data.course.description, data.course.price, data.course.priceWithTax, data.course.isPublic, data.course.videoIntro, data.course.modules, data.course.contents, data.course.user)

          // this.course = data.course
          this.courseLoaded = true
        } else {
          this.alert.text = data.message
          this.alert.color = 'error'
          this.alert.show = true
        }
      }).catch(err => {
        console.error(err)

        this.alert.text = 'Erro ao carregar o curso'
        this.alert.color = 'error'
        this.alert.show = true
      }).finally(() => {
        this.loadingCourse = false
      })
    },
  }
}
</script>
<style scoped>
.black {
  background-color: black;
}
</style>
